import React from 'react'
import "./BlogPost.css";

import holyweek from "../../Assets/b72/holyweek.jpg"

function Blog72() {
    return (
        <div className='container-fluid my-5'>
            <div className='row mb-5'>
                <div className='col blog-text text-center'>
                    <h1>In observance of the Lenten season</h1>
                    <h6>March 27, 2026 at 06:00 PM</h6>
                </div>
            </div>

            <div className='row align-items-center justify-content-center mx-5 gx-5 gy-5'>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 col-xxl-5'>
                    <img src={holyweek} className="blog-img" alt="..." />
                </div>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 blog-text'>
                    <p>MYT will be closed from April 2 to April 5. While our office will be on break, our communication lines will remain open for any concerns.</p>
                    <p>You may send a ticket to our support for any urgent system concerns: https://myt-support.com/</p>
                    <p>May this season be a gentle reminder for all of us to pause, reflect, and spend meaningful time with our loved ones. 
                        Thank you for your understanding, and we wish everyone a peaceful and blessed Holy Week.</p>
                    <p><a href='https://www.facebook.com/hashtag/mytsoftdevsolutions' target='_blank' className='blog-link'>
                        #MYTSoftDevSolutions</a>
                        <a href='https://www.facebook.com/hashtag/mytsoftdevsolutions' target='_blank' className='blog-link'>
                        #MYTSoftDevSolutions</a>
                        <a href='https://www.facebook.com/hashtag/builttolast' target='_blank' className='blog-link'>
                        #BuiltToLast</a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Blog72;
